import React from "react";
import NumberFormat from "react-number-format";

const TextInputNumberFormik = ({ formik, field, format, disable, evento }) => (
  <>
    <NumberFormat
      id={field}
      name={field}
      format={format}
      thousandSeparator="."
      decimalSeparator=","
      decimalScale="2"
      allowLeadingZeros={false}
      disabled={formik.isSubmitting || disable}
      value={formik.values[field]}
      onChange={formik.handleChange}
      onBlur={evento}
      isInvalid={formik.touched[field] && formik.errors[field]}
      className="form-control"
    />
    {formik.touched[field] && formik.errors[field] && <div className="invalid-feedback">{formik.errors[field]}</div>}
  </>
);

export default TextInputNumberFormik;
